<app-leveltwo [pageName]="'Builders Exclusion CONEX'">
    <div heading="General Info" class="General">
      <h3>{{'Builders.PageTitle'|translate}}</h3>

      <p>{{'Builders.text'|translate}}</p>

      <h4>{{'Builders.FilingRequirements'|translate}}</h4>
      <p>{{'Builders.Thedeveloper'|translate}}</p>
      <p>{{'Builders.Buildersare'|translate}}</p>
      <ol>
        <li>{{'Builders.Theproperty'|translate}}</li>
        <li>{{'Builders.Amap'|translate}}</li>
        <li>{{'Builders.Onlysingle'|translate}}</li>
      </ol>

      <h4>{{'Builders.TaxExclusion'|translate}}</h4>
      <p>{{'Builders.thebuilder'|translate}}</p>
      <!--
      <button type="button" class="btn btn-primary">{{'Builders.newconstbutton'|translate}}</button>
      -->

    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
